// eslint-disable-next-line import/prefer-default-export
export const getOptionAnswerValueById = (
  optionId,
  options,
  otherInputValue
) => {
  if (optionId === 'other-option') {
    return otherInputValue;
  }

  const filteredOption = options.filter(
    (option) => String(optionId) === String(option.id)
  );

  // Each option has a key and a value. Confusingly the key actually refers to the filterable input value which will be included in submissions and the value refers to the label to show for the option.
  return filteredOption.length ? filteredOption[0]?.key : '';
};
